"use client";

import Header from "../components/_ui/Header/Header";
import Footer from "../components/Footer/Footer";
import Toaster from "../components/_ui/Toast/Toaster/Toaster";
import CreateReportModalButton from "../components/CreateReportModal/CreateReportModalButton/CreateReportModalButton";
import CookieBannerDynamicRender from "../components/_ui/CookieBanner/CookieBannerDynamicRender";
import LogoLight from "../images/Logo/LogoLight.svg";
import Logo from "../images/Logo/Hub.svg";
import Typography from "../components/_ui/Typography/Typography";
import ButtonLink from "../components/_ui/Buttons/ButtonLink/ButtonLink";

export const dynamic = "force-static";

/**
 * Error Page
 * !Important! - Please avoid putting api calls in here, Pretty sue the 404 link below is applicable to the
 * error page as well.
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/not-found
 */
export default function ErrorPage() {
    return (
        <>
            <CookieBannerDynamicRender />
            <Header mobileLogo={Logo} desktopLogo={LogoLight}>
                <div className="flex justify-center">
                    <CreateReportModalButton buttonVariant="secondarySolid" />
                </div>
            </Header>
            <main className="flex items-center justify-center flex-grow mx-auto w-full max-w-app-container space-y-100 p-100 md:p-150 lg:p-200 pb-0">
                <div className="flex flex-col justify-between space-y-100 max-w-small">
                    <Typography as="p" variant="subTitle" color="quiet" size={1000}>500</Typography>
                    <div>
                        <Typography as="h1" variant="heading" size={300}>
                            There was an error with the application.
                        </Typography>
                        <Typography as="p" variant="paragraph">
                            You can either return to the homepage, or contact our support team directly
                            to assist with your enquiry.
                        </Typography>
                    </div>
                    <div className="flex gap-100">
                        <ButtonLink href="/">Back to homepage</ButtonLink>
                        <ButtonLink
                            variant="primaryBorder"
                            href="https://vergo.uk/contact/"
                            rel="noopener noreferrer"
                        >
                            Contact support
                        </ButtonLink>
                    </div>
                </div>
            </main>
            <Footer />
            <Toaster />
        </>
    );
};
